import React from "react";
import { Typography } from "@mui/material";
import { PricingMinusIcon, PricingPlusIcon } from "../../assets/icons";
import { PRICING_COLUMNS, FIELD_KEYS } from "./constants";
import { toDisplayRate, getNodeColumnKey } from "./service";

const PricingRow = ({
  node,
  selectedNodeId,
  showRatesColumns,
  gridTemplateColumns,
  hasChildren,
  isExpanded,
  percentValue,
  flatValue,
  percentEditable,
  flatEditable,
  nodeErrors,
  onSelect,
  onToggle,
  onFieldChange,
  onBlur,
}) => {
  const selectedClass = selectedNodeId === node.id ? "row-selected" : "";

  return (
    <div
      className={`body-row ${selectedClass}`}
      onClick={() => onSelect(node.id)}
      role="row"
      style={{ gridTemplateColumns }}
    >
      {PRICING_COLUMNS.slice(0, 5).map((col) => {
        const currentColumnKey = getNodeColumnKey(node.nodeType);
        
        if (currentColumnKey === col.key) {
          return (
            <div
              key={col.key}
              className="cell tree-cell"
              style={{ display: "flex", alignItems: "center", position: "relative", paddingLeft: "24px" }}
            >
              {hasChildren && (
                <button
                  className="toggle-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle(node.id);
                  }}
                  type="button"
                  style={{ position: "absolute", left: "2px", display: "inline-flex", padding: 0, border: "none", background: "none", cursor: "pointer" }}
                  aria-label={`${isExpanded ? "Collapse" : "Expand"} ${node.label}`}
                >
                  {isExpanded ? <PricingMinusIcon /> : <PricingPlusIcon />}
                </button>
              )}
              <span>{node.label}</span>
            </div>
          );
        }

        const targetIndex = PRICING_COLUMNS.findIndex((c) => c.key === currentColumnKey);
        const colIndex = PRICING_COLUMNS.findIndex((c) => c.key === col.key);
        return colIndex < targetIndex ? <div key={col.key} className="cell" /> : null;
      })}

      {showRatesColumns && (
        <>
          {/* MDR % Column */}
          <div className="cell rate-cell" style={{ gridColumn: 6 }}>
            {percentEditable ? (
              <>
                <input
                  className={`rate-input ${nodeErrors?.mdrPercent ? "rate-input-error" : ""}`}
                  type="text"
                  value={percentValue}
                  data-testid={`mdr-percent-input-${node.id}`}
                  onChange={(e) => onFieldChange(node, FIELD_KEYS.mdrPercent, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  // ─── VISUAL RESET TRIGGER ON BLUR ──────────────────────────────
                  onBlur={(e) => {
                    e.stopPropagation();
                    if (typeof onBlur === "function") {
                      onBlur(node, FIELD_KEYS.mdrPercent, e.target.value);
                    }
                  }}
                />
                {nodeErrors?.mdrPercent && (
                  <span className="input-error">{nodeErrors.mdrPercent}</span>
                )}
              </>
            ) : (
              <Typography className={node?.rate?.source === "DEFAULT" ? "muted-rate" : ""}>
                {toDisplayRate(node?.rate?.mdrPercent, node?.rate?.source)}
              </Typography>
            )}
          </div>

          {/* MDR FLAT Column */}
          <div className="cell rate-cell" style={{ gridColumn: 7 }}>
            {flatEditable ? (
              <>
                <input
                  className={`rate-input ${nodeErrors?.mdrFlat ? "rate-input-error" : ""}`}
                  type="text"
                  value={flatValue}
                  data-testid={`mdr-flat-input-${node.id}`}
                  onChange={(e) => onFieldChange(node, FIELD_KEYS.mdrFlat, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                  // ─── VISUAL RESET TRIGGER ON BLUR ──────────────────────────────
                  onBlur={(e) => {
                    e.stopPropagation();
                    if (typeof onBlur === "function") {
                      onBlur(node, FIELD_KEYS.mdrFlat, e.target.value);
                    }
                  }}
                />
                {nodeErrors?.mdrFlat && (
                  <span className="input-error">{nodeErrors.mdrFlat}</span>
                )}
              </>
            ) : (
              <Typography className={node?.rate?.source === "DEFAULT" ? "muted-rate" : ""}>
                {toDisplayRate(node?.rate?.mdrFlat, node?.rate?.source)}
              </Typography>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(PricingRow);